/**
 *
 * @type {{forgotPassword: string, auth: string, register: string}}
 */
export const authRoutes = {
    auth: '/auth',
    register: '/auth/register',
    forgotPassword: '/auth/forgotPassword'
};
